import { gql } from "apollo-boost";

export const PRODUCT_BY_SPECIALTIES_AND_MEDICAL = gql`
  query productBySpecialtiesAndMedical(
    $where: productBySpecialtiesAndMedicalInput
  ) {
    productBySpecialtiesAndMedical(where: $where) {
      id
      name
    }
  }
`;

export const GET_CONSULTORY_SERVICES = gql`
  query consultoryServices(
    $where: ConsultoryServicesInput
    $relations: [String]
  ) {
    consultoryServices(where: $where, relations: $relations) {
      product {
        id
        name
      }
      consultoryServicesDetail {
        id
        insuredContrated
        insuredCoverage
        insuredCopay
        consultoryFee
        consultoryDifferent
        enabled
        ars {
          id
          name
        }
      }
    }
  }
`;

export const GET_QUOTATIONS_BY_APPOINTMENT = gql`
  query getQuotationsByAppointment(
    $where: quotationsByAppointmentI
    $relations: [String]
  ) {
    getQuotationsByAppointment(where: $where, relations: $relations) {
      quotations {
        id
        date
        totalConsultoryDifferent
        totalConsultoryFee
        totalInsuredCopay
        totalInsuredContrated
        totalConsultoryCoverage
        patientId
        pharmacyProviderId
        appointmentId
        arsId
        branchOfficeId
        code
        expirationDate
        quotationsDetails {
          id
          quantity
          insuredContrated
          insuredCoverage
          insuredCopay
          consultoryFee
          consultoryDifferent
          wasBilled
          quotationId
          availableQuantity
          invoicedAmount
          product {
            id
            name
            requiresResult
          }
        }
      }
    }
  }
`;
